import { PubSub } from "./pubsub";

export class SpinnerManager {
  private static readonly SHOW_SPINNER_EVENT = "showSpinner";
  private static readonly HIDE_SPINNER_EVENT = "hideSpinner";
  private static readonly LOADER_ELEMENT_ID = "boot-loader";

  private showSpinnerCount = 0;
  private hideSpinnerCount = 0;

  constructor(private readonly pubsub: PubSub) {}

  public initialize(): void {
    console.info(
      `[Spinner] Registering global listeners for '${SpinnerManager.SHOW_SPINNER_EVENT}' and '${SpinnerManager.HIDE_SPINNER_EVENT}'.`
    );

    this.pubsub.subscribe(
      SpinnerManager.SHOW_SPINNER_EVENT,
      this.handleShowSpinner
    );
    this.pubsub.subscribe(
      SpinnerManager.HIDE_SPINNER_EVENT,
      this.handleHideSpinner
    );
  }

  private handleShowSpinner = (event?: Event): void => {
    this.showSpinnerCount += 1;

    this.syncLoaderVisibilityFromCounters();
  };

  private handleHideSpinner = (event?: Event): void => {
    this.hideSpinnerCount += 1;

    this.syncLoaderVisibilityFromCounters();
  };

  private syncLoaderVisibilityFromCounters(): void {
    const spinnerDiff = this.showSpinnerCount - this.hideSpinnerCount;

    if (spinnerDiff <= 0) {
      this.setLoaderVisibility(false);
      this.showSpinnerCount = 0;
      this.hideSpinnerCount = 0;
      return;
    }

    this.setLoaderVisibility(true);
  }

  private setLoaderVisibility(isVisible: boolean): void {
    const loader = document.getElementById(SpinnerManager.LOADER_ELEMENT_ID);
    if (!loader) {
      console.warn("[Spinner] boot-loader element not found.");
      return;
    }

    if (isVisible) {
      loader.classList.add("k-i-loading");
    } else {
      loader.classList.remove("k-i-loading");
    }
    document.body.classList.toggle("spinner-visible", isVisible);
    loader.style.display = isVisible ? "block" : "none";
  }
}
